module.exports = __webpack_public_path__ + "img/Portada.fe551935.png";